export default function mediaItemGrid() {
  return {
    _id: false,
    type: 'droplet.mediaItemGrid',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    hideFilters: false,
    customCategories: [],
    customList: false,
    paginate: 24,
    placeholder: 'Search...',
    sortKey: false,
    showDate: false,
    sort: 'newest',
    match: 'all',
    filterText: 'Filters',
    newWindow: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/media-item-grid/droplet.schema.js